/*
 Tag Carrier include extend from L.LabelCarrierHub,
 to show as time label, and the key is the datetime.getTime().
 This require cb.data.js
*/


(function (window, document, undefined) {


L.TimeLabelCarrierHub = L.LabelCarrierHub.extend({
    options: {
        //LST: true,
        format: "%m/%d %H:%M",
        labelOptions: {}
    },

    initialize: function(map, options) {
        L.setOptions(this, options);
        this._map = map;
        this._carries = {};
        this._contents = {};
    },

    onboard: function(dtime, layer) {
        //
        // dtime is Date object or number by Date.getTime()
        //
        //if (dtime instanceof Date) {
        //    dtime = dtime.getTime();
        //}
        var self = this;
        self.setContent(dtime);
        if (dtime instanceof Date) {
            dtime = dtime.getTime();
        }
        L.LabelCarrierHub.prototype.onboard.call(self, dtime, layer);
    },

    setContent: function(dtime) {
        if (dtime instanceof Date) {
            key = dtime.getTime();
        }
        else {
            key = dtime;
            dtime = new Date(dtime);
        }

        var self = this;
        if (self.options.LST) {
            dtime = dtime.toLocal();
        }
        var content = dtime.formatDate(self.options.format);
        self._contents[key] = content;

        var _carrie = self._carries[key];
        if (_carrie) {
            _carrie.setContent(content);
        }
    }
});


/**
 *
 * This is a special class defind time lable by inittime and tau,
 * and also using tau as key.
 * And that could eays deside show or hide label by tau selected.
 *
 */
L.TauLabelCarrierHub = L.TimeLabelCarrierHub.extend({
    options: {
        format: "%m/%d %H:%M",
        labelOptions: {},
        show_taus: [24, 48, 72]
    },

    initialize: function(init, map, options) {
        L.setOptions(this, options);
        this._map = map;
        this._carries = {};
        this._contents = {};

        if (init instanceof Number) {
            init = new Date(init);
        }
        this._init = init;

        this._tau_selected = {};
        if (this.options.show_taus) {
            for (var i=0; i<this.options.show_taus.length; i++) {
                var tau = this.options.show_taus[i];
                this._tau_selected[tau] = true;
            }
        }
    },

    onboard: function(tau, layer) {
        var self = this;
        var dtime = self._init.addHours(tau);
        self.setContent(dtime, tau);
        L.LabelCarrierHub.prototype.onboard.call(self, tau, layer);
    },

    setContent: function(dtime, tau) {
        if (dtime instanceof Number) {
            dtime = new Date(dtime);
        }

        var self = this;
        var content = dtime.strftime(self.options.format);
        self._contents[tau] = content;

        var _carrie = self._carries[tau];
        if (_carrie) {
            _carrie.setContent(content);
        }
    },

    addToMap: function(label) {
        var self = this;
        for (var tau in self._carries) {
            var carrie = self._carries[tau];
            if (label == carrie && self._map) {
                if (self._tau_selected[tau]) {
                    self._map.addLayer(carrie);
                }
                else {
                    self._map.removeLayer(carrie);
                }
                break;
            }
        }
    },

    toggleTau: function(tau, selected) {
        var self = this;
        if (typeof(selected) == 'undefined') {
            if (!self._tau_selected[tau]) { self._tau_selected[tau] = true; }
            else { self._tau_selected[tau] = false; }
        }
        else {
           self._tau_selected[tau] = selected;
        }

        self.remap();
    }
});


}(this, document));



// WEBPACK FOOTER //
// ./src/assets/cb/leaflet/leaflet.timelabel-carrier.js